import { FieldErrors, useForm, UseFormReturn } from 'react-hook-form'
import { AmountUnit, ConsignmentItemFormValues } from 'features/declaration/consignment-item/models/schema'
import { blankConsignee } from 'features/declaration/models/blankItems'
import { ErrorResult } from '../../../../shared/models/types'
import { useDeclarationEditorContext, useServerRequirementsContext } from '../../form/contexts/DeclarationEditorContext'
import consignmentItemFormResolver from './consignmentItemFormResolver'
import ConsignmentItemFormResolverContext from './ConsignmentItemFormResolverContext'
import { ConsignmentItemFormValuesSaveResult } from './useSaveConsignmentItemForm'

export type ConsignmentItemFormSaveResult =
  { success: true; data: ConsignmentItemFormValuesSaveResult }
  | {
    success: false
    errorReason: 'general' | 'validation' | 'unexpected'
    formErrors?: FieldErrors<ConsignmentItemFormValues>
    errors?: ErrorResult[]
    error?: unknown
  }

export const initialFormData: ConsignmentItemFormValues = {
  id: null,
  sequenceNumber: 0,
  declarationGoodsItemNumber: 0,
  countryOfDispatch: '',
  countryOfDestination: '',
  referenceNumberUCR: '',
  commodityDescriptionOfGoods: '',
  commodityHarmonizedSystemSubHeadingCode: '',
  commodityCombinedNomenclatureCode: '',
  goodsMeasureGrossMass: 0,
  goodsMeasureNetMass: 0,
  dangerousGoods: [],
  additionalSupplyChainActor: [],
  previousDocument: [],
  supportingDocument: [],
  transportDocument: [],
  additionalReference: [],
  additionalInformation: [],
  packaging: [],
  consignee: blankConsignee,
  deleted: false,
  price: null,
  dutyRate: null,
  dutyAmount: null,
  dutyRateUnit: AmountUnit.PERCENTAGE,
  vatRate: null,
  excise: null,
  initialPrice: null,
  initialPriceCurrency: 'EUR',
  transportEquipment: [],
  containerIndicator: 'false',
  passiveBorderTransportMeans: [],
  differentPassiveBorderTransportMeans: false,
}

function useConsignmentItemForm() {
  const { validationContextRef } = useDeclarationEditorContext()
  const { serverValidationResult } = useServerRequirementsContext('consignmentItem')

  const resolverContext: ConsignmentItemFormResolverContext = {
    validationContextRef,
    serverValidationResult,
  }

  const form: UseConsignmentItemFormReturn = useForm<ConsignmentItemFormValues>({
    mode: 'onBlur',
    defaultValues: initialFormData,
    resolver: consignmentItemFormResolver,
    context: resolverContext,
  })

  return {
    form,
  }
}

export type UseConsignmentItemFormReturn = UseFormReturn<ConsignmentItemFormValues>

export default useConsignmentItemForm
